export enum QMS_ITEM_STATUS {
  WAITING,
  IN_PROGRESS,
  DONE,
  MISS_CALL,
}

export enum MENU_TYPE {
  WAITING = 'WAITING',
  IN_PROGRESS = 'IN_PROGRESS',
  MISS_CALL = 'MISS_CALL',
  DONE = 'DONE',
}

export const menus = [
  { key: MENU_TYPE.WAITING, name: 'QMS.Waiting' },
  { key: MENU_TYPE.IN_PROGRESS, name: 'QMS.In Progress' },
  { key: MENU_TYPE.MISS_CALL, name: 'QMS.Miss Call' },
  { key: MENU_TYPE.DONE, name: 'QMS.Done' },
];
